import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { RootState } from '../../app/store';
import getAxiosInstance, { getConfig, getUrl } from '../AxiosSetup';

export interface SupplierStatusState {
  status: 'idle' | 'loading' | 'failed' | 'success';
  data: any;
}

const initialState: SupplierStatusState = {
  status: 'idle',
  data: null,
};

export const putSupplierStatus = createAsyncThunk(
  'Put Supplier Status',
  async (data: { applicationId: string; supplierStatus: string }, { rejectWithValue }) => {
    const axios = getAxiosInstance();
    try {
      const response = await axios.put(
        getUrl('application/supplier-status', {}),
        data,
        getConfig(true),
      );
      return response.data;
    } catch (e: any) {
      if (!e.response) {
        throw e;
      }
      return rejectWithValue(e.response.data);
    }
  },
);

export const PutSupplierStatusSlice = createSlice({
  name: 'Put Supplier Status',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(putSupplierStatus.pending, (state) => {
        state.status = 'loading';
      })
      .addCase(putSupplierStatus.fulfilled, (state, action) => {
        state.status = 'success';
        state.data = action.payload;
      })
      .addCase(putSupplierStatus.rejected, (state, action) => {
        state.status = 'failed';
        state.data = action.payload;
      });
  },
});

export const selectPutSupplierStatusLoading = (state: RootState) => state.putSupplierStatus.status;
export const selectPutSupplierStatusData = (state: RootState) => state.putSupplierStatus.data;

export default PutSupplierStatusSlice.reducer;
